
/* eslint-disable */

<template>
    <v-sheet>
        <router-view :key="$route.fullPath"/>
    </v-sheet>
</template>
<script>

export default {
    name: 'page',
    components: {
    },
    
}
</script>
